import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import LinkWrapper from '../../components/LinkWrapper';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from '../FrequentlyAskedQuestions';
import { getNonProfitsUrlPublic, getStartupsUrlPublic } from '../FrequentlyAskedQuestionsPublicPageUrls';
import { useFaqToggleHandler, useLinkClickHandler } from '../FrequentlyAskedQuestionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANGUAGE_OFFERING_URL = 'https://knowledge.hubspot.com/help-and-resources/hubspot-language-offerings';
const startupsHref = getStartupsUrlPublic('pricing-servicepage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-servicepage');
export const HsocV2Faqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    maxInlineSize: "1200px",
    margin: "auto",
    children: /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
      children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatIsHubSpot.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatIsHubSpot.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatIsHubSpot', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatIsHubSpot.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatAreHubSpotCredits', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatAreHubSpotCredits.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.answer"
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.howManyCredits', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.howManyCredits.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.answer",
          options: {
            languageLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: LANGUAGE_OFFERING_URL,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatSupport.languageOffering', LANGUAGE_OFFERING_URL),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.languageOffering"
              })
            })
          }
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatSupport.question')
      }), /*#__PURE__*/_jsx(ExpandingFAQ, {
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatDiscounts.question"
        }),
        Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatDiscounts.answer",
          options: {
            startupsLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: startupsHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatDiscounts.hubSpotForStartups', startupsHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatDiscounts.hubSpotForStartups"
              })
            }),
            nonprofitsLink: /*#__PURE__*/_jsx(LinkWrapper, {
              href: nonprofitsHref,
              external: true,
              onClick: () => handleLinkClick('hsocV2.whatDiscounts.hubSpotForNonprofits', nonprofitsHref),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-page-components.frequentlyAskedQuestions.hsocV2.whatDiscounts.hubSpotForNonprofits"
              })
            })
          }
        }),
        onExpandedChange: () => handleFaqToggle('hsocV2.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.hsocV2.whatDiscounts.question')
      })]
    })
  });
};
export default HsocV2Faqs;